var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.187 3.165a18.194 18.194 0 0 0-9.312 1.18A15.547 15.547 0 0 0 5.518 6.97c-5.882 5.114-4.496 13.155 4.973 15.74.522.146 1.051.254 1.586.326 4.823.624 6.192-2.792 1.739-5.023-1.685-.841-3.346-2.067-4.288-3.707-1.749-3.043-.356-6.408 3.663-8.052l.048-.02c3.254-1.309 8.215-1.485 14.61.548a18.193 18.193 0 0 0-8.661-3.617zm2.32 6.864c2.543.694 4.503 1.788 5.89 3.1 3.802 3.588 3.39 8.899-.914 12.646-4.274 3.715-10.723 4.798-16.063 3.328a18.016 18.016 0 0 1-6.265-3.14c3.425 1.087 7.638 1.894 11.436 1.367 2.392-.324 4.99-1.682 5.79-2.407 3.14-2.85 2.367-7.408-3.195-10.191-4.9-2.455-2.744-6.349 3.307-4.703h.015z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSys);
export default __webpack_public_path__ + "static/media/SYS.9efed231241a6c55c89af124d1bb2fbf.svg";
export { ForwardRef as ReactComponent };